package ld.scenes;
import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;
import pixi.extras.AnimatedSprite;

import stocking.ColoredBitmapText;
import stocking.SceneManager;

import tweenx909.TweenX;
import tweenxcore.color.RgbColor;

import ld.NotificationWindow;
import ld.scenes.MenuScene;
import stocking.AudioManager;


import stocking.Scene;

typedef LDFlag = {
	var container : Container;
	var event : ld.Types.LDDayEvents;
}

typedef LDPlayerStat = {
	var name : String;
	var value : Int;
}

typedef LDPlayer = {
	var stats : Array<LDPlayerStat>;
}

class GameScene extends Scene
{
	var gameData : ld.Types.LDGameInfoFile;

	var flags = new Array<LDFlag>();

	var labelDay : BitmapText;
	var shadowDay : BitmapText;
	var containerSubGroupPicker : Container = new Container();
	var containerTextBox : Container = new Container();
	var containerScene : Container = new Container();
	var containerFlags : Container = new Container();
	var containerBG : Container = new Container();
	var containerNotification : Container = new Container();
	var desiredText = "";
	var infoTextBox : BitmapText;
	var infoTextTimer = 0.;
	var gameover = false;

	var activeEvent : Null<ld.Types.LDEvent>;
	var textIndex : Int = -1;
	var flagIndex : Int = -1;
	var dayIndex : Int = -1;

	var bgPosition = { x: 0., y: 0.};

	var player : LDPlayer = { stats: [] };
	var notificationWindow : NotificationWindow;
	var music : js.html.Audio;


	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );
	}

    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/gemu_bg.png"},
			{ filename: "assets/eventflag_active.png"},
			{ filename: "assets/eventflag_inactive.png"},
			{ filename: "assets/bg_tiled.png"},
			{ filename: "assets/day_container.png"},
			{ filename: "assets/choice_container.png"},
			// BGs
			{ filename: "assets/bg0000.png", alias: "bg_train"},
			{ filename: "assets/bg0001.png", alias: "bg_work"},
			{ filename: "assets/bg0002.png", alias: "bg_home"},
			{ filename: "assets/bg0003.png", alias: "bg_bar"},
			{ filename: "assets/bg0004.png", alias: "bg_bento"},
			{ filename: "assets/bg0005.png", alias: "bg_onigiri"},
			{ filename: "assets/bg0006.png", alias: "bg_combini"},
			{ filename: "assets/bg_train_night.png", alias: "bg_train_night"},
			// BGs
			{ filename: "assets/Untitled-20000.png", alias: "expr_normal"},
			{ filename: "assets/Untitled-20001.png", alias: "expr_worried"},
			{ filename: "assets/Untitled-20002.png", alias: "expr_relax"},
			{ filename: "assets/Untitled-20003.png", alias: "expr_sigh"},
			{ filename: "assets/Untitled-20004.png", alias: "expr_cry"},
			{ filename: "assets/Untitled-20005.png", alias: "expr_angry"},
			{ filename: "assets/Untitled-20006.png", alias: "expr_wat"},
			
		];
		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];
		loaderGifs = [
			//"assets/scene_train_1.gif",
		];
		// @todo switch this to alias model....
		loaderSfx = [
			"assets/Sunny_Loop.ogg",
			"assets/hover.ogg",
			"assets/fail.ogg",
			"assets/notif.ogg",
			"assets/succes.ogg",
			"assets/decline.ogg",
			"assets/accept.ogg",
		];

		loaderData = [
			// 1993 Mazda NOT AN IMAGE
			{ filename: "assets/gamedata.json", alias: "gamedata"},
		];
		super.preload();
    }

	public override function enter()
	{
		super.enter();

		if( !dataCache.exists('gamedata') )
		{
			throw("tried to enter before gamedata loaded. How??");
		}

		gameData = dataCache.get('gamedata');

		var storage = js.Browser.getLocalStorage();
		if( storage != null )
		{
			var storedJSON = storage.getItem("local_gamedata" );

			if( storedJSON != null )
			{
				gameData = haxe.Json.parse( storedJSON );
				trace("Loaded from LS");
			}
		}

		notificationWindow = new NotificationWindow(containerNotification);	

		container.addChild(containerBG);

		var bg = new Sprite( Texture.fromImage("assets/gemu_bg.png") );
		this.container.addChild(bg);

		container.interactive = true;
		container.click = container.tap = function( event : pixi.interaction.InteractionEvent ) { AdvanceText(); };

		container.addChild(containerFlags);

		var frame = new Sprite( Texture.fromImage("assets/day_container.png") );
		
		frame.position.x = 10;
		frame.position.y = 8;

		this.container.addChild(frame);

		shadowDay = new BitmapText("---", { font: "16px khdot16" });

		shadowDay.position.x = 21;
		shadowDay.position.y = 16;
		shadowDay.tint = 0x0;
		this.container.addChild(shadowDay);

		labelDay = new BitmapText("---", { font: "16px khdot16" });

		labelDay.position.x = 20;
		labelDay.position.y = 15;
		this.container.addChild(labelDay);

		//containerSubGroupPicker.position.x = 140;
		//containerSubGroupPicker.position.y = 115;
		container.addChild(containerSubGroupPicker);

		containerTextBox.position.x = 135;
		containerTextBox.position.y = 115;
		container.addChild(containerTextBox);

		containerScene.position.x = 133;
		containerScene.position.y = 28;
		container.addChild(containerScene);
	
		containerNotification.y = 186;
		container.addChild(containerNotification);

		infoTextBox = new BitmapText( '???', { font: "12px khdot12" } );
		infoTextBox.maxWidth = 130;
		containerTextBox.addChild(infoTextBox);

		container.alpha = 0;

		music = AudioManager.instance.play("Sunny_Loop");
		music.loop = true;
		music.volume = 0.3;
		

		ProcessDay();
		
/*

		// Debug
		var txt = new BitmapText( "Stats", { font: "12px khdot12" } );
		txt.position.x = 100;
		txt.position.y = 5;
		txt.interactive = true;
		txt.click = function( event : pixi.interaction.InteractionEvent ) { trace( player ); };
		container.addChild(txt);
		
		var txt = new BitmapText( "Editor", { font: "12px khdot12" } );
		
		txt.position.x = 150;
		txt.position.y = 5;
		txt.interactive = true;
		txt.click = function( event : pixi.interaction.InteractionEvent ) { SceneManager.instance.transitionToScene( new EditorScene( renderer, stage ) );
 };
		container.addChild(txt);
*/
		//trace(gifCache.get("assets/scene_train_1.gif")[2]);
		//container.addChild( new Sprite( gifCache.get("assets/scene_train_2.gif")[2] ) );
		//var s = new AnimatedSprite( gifCache.get("assets/scene_train_2.gif"), true );
		//container.addChild( s );
		//s.animationSpeed = 0.1;
		//s.play();


		// Fill BG container
		for( x in 0 ... cast 1 + 320 / 64 )
		{
			for( y in 0 ... cast 1 + 224 / 64)
			{
				var s = new Sprite( Texture.fromImage( "assets/bg_tiled.png" ) );
				s.position.x = 64 * x;
				s.position.y = 64 * y;
				containerBG.addChild( s );
			}
		}

		// Draw frame over fuckeverything
		var g = new Graphics();
		g.lineStyle(1,0);
		g.moveTo(0,0);
		g.lineTo(320,0);
		g.lineTo(320,224);
		g.lineTo(0,224);
		g.lineTo(0,0);

		container.addChild(g);
		
	}

	public override function tick( delta : Float )
	{
		bgPosition.x += 0.5;
		bgPosition.y += 1;

		bgPosition.x = bgPosition.x % 64;
		bgPosition.y = bgPosition.y % 64;

		containerBG.position.x = -Math.floor(bgPosition.x);
		containerBG.position.y = -Math.floor(bgPosition.y);

		notificationWindow.Tick( delta );

		infoTextTimer += delta;

		var nChar = infoTextTimer * 0.45;
		if( desiredText != infoTextBox.text && infoTextBox.text.length < nChar )
		{
			infoTextBox.text = desiredText.substr(0, Math.floor( nChar ) );
		}

	}

	public function ProcessDay( )
	{
		dayIndex = ( dayIndex + 1 ) % 7;
		var day = gameData.days[dayIndex];

		// Check for victory/fail conditions
		if( GetStat('fired') > 0 )
		{
			trace("ripperino");
			TweenX.to( music, { volume: 0 } ).time(1).onFinish(function(){
				music.pause();
			});
			AudioManager.instance.play("fail");
			
			SceneManager.instance.transitionToScene(new MenuScene( renderer, stage ) );
			
			return;
		}

		if( GetStat('won') > 0 )
		{
			trace("weiner!");
			
			
			TweenX.to( music, { volume: 0 } ).time(1).onFinish(function(){
				music.pause();
			});
			
			SceneManager.instance.transitionToScene(new MenuScene( renderer, stage ) );
			
			return;
		}
		

		labelDay.text = shadowDay.text = day.name.toUpperCase();


		containerFlags.removeChildren();
		flags = new Array<LDFlag>();
		// Build event stack and flags
		for( i in 0 ... day.events.length )
		{
			var event = day.events[i];
			var flagContainer = new Container();

			var flagSprite = new Sprite( Texture.fromImage( "assets/eventflag_inactive.png" ));
			var flagText = new BitmapText( event.name, { font: "12px khdot12" } );
			flagText.position.x = 35;
			flagText.position.y = 4;

			flagContainer.addChild(flagSprite);
			flagContainer.addChild(flagText);

			flagContainer.position.x = 27;
			flagContainer.position.y = 300;

			containerFlags.addChild(flagContainer);

			var flag : LDFlag = {
				event: event,
				container: flagContainer
			};

			flags.push(flag);			
		}

		flagIndex = -1;

		TweenX.to( container, { alpha: 0 } ).time(1).onFinish(function(){
			ProcessFlag();
			TweenX.to( container, { alpha: 1 } ).time(0.5);
		});

		
	}

	public function ProcessFailCheck()
	{
		
		var subgroup = GetSubGroups('failcheck');
		if( !gameover && subgroup != null && subgroup.length > 0)
		{
			TweenX.to( container, { alpha: 0 } ).time(1).onFinish(function(){
				gameover = true;
				PickSubGroup( "failcheck", subgroup[0] );
				TweenX.to( container, { alpha: 1 } ).time(0.5);
			});
			
		} else {
			ProcessDay();
		}


	}

	public function ProcessFlag()
	{
		activeEvent = null;
		if( flagIndex >= 0 && flags[flagIndex] != null )
		{
			var sprite : Sprite = cast flags[flagIndex].container.children[0];
			sprite.texture = Texture.fromImage( "assets/eventflag_inactive.png" );
		}

		flagIndex++;
		// Set the top flag active
		var activeFlag = flags[flagIndex];
		if( activeFlag == null )
		{
			ProcessFailCheck();
			return;
		}

		var top = 50 + flagIndex * -30;
		var distance = 30;
		var duration = 0.2;
		for( i in 0 ... flags.length )
		{
			TweenX.to( flags[i].container.position, { y: top + i * distance } ).time(duration).delay(i*duration);
		}

		var sprite : Sprite = cast activeFlag.container.children[0];
		sprite.texture = Texture.fromImage( "assets/eventflag_active.png" );

		var subGroups = GetSubGroups( activeFlag.event.group );

		if( subGroups.length > 1 )
		{
			ShowSubGroupPicker( activeFlag.event.group, subGroups );
		}
		else if( subGroups.length == 1 )
		{
			PickSubGroup( activeFlag.event.group, subGroups[0] );
		}
		else 
		{
			// !!!!!
			trace("No events defined for this group. :thinking:");
			ProcessFlag();
		}
	}

	public function GetSubGroups( group : String ) : Array<String>
	{
		var groups = new Array<String>();

		// Walk our events list
		for( event in gameData.events )
		{
			if( event.group == group )
			{
				// Do we meet the requirements?
				var pass = true;
				for( requirement in event.requirements )
				{
					if( !CheckStat( requirement.attribute, requirement.value, requirement.operator ) )
					{
						
						pass = false;
					}
				}

				if( pass && groups.indexOf( event.subgroup ) == -1 )
					groups.push( event.subgroup);
			}
		}

		return groups;
	}

	public function ShowSubGroupPicker( group : String, subgroups : Array<String> )
	{
		containerSubGroupPicker.removeChildren();

		containerTextBox.visible = true;
		infoTextBox.text = "";
		desiredText = "I'll...";
		infoTextTimer = 0;
		
		//var pickText = new BitmapText( "Pick subgroup:", { font: "12px khdot12" } );
		
		//containerSubGroupPicker.addChild(pickText);

		for( i in 0 ... subgroups.length )
		{
			var subgroup = subgroups[i];


			var choiceContainer = new Container();

			var text = GetStatLocalization( group + "." + subgroup);
			if( text == null || text.length == 0 )
				text = subgroup;

			var button = new Sprite( Texture.fromImage( "assets/choice_container.png" ) );
			choiceContainer.addChild(button);

			var shadowText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
			shadowText.position.y = 8;
			shadowText.anchor.x = 0.5;
			shadowText.position.x = 95/2 + 1;
			shadowText.tint = 0x0;
			//optionText
			shadowText.align = BitmapTextAlign.CENTER;
			choiceContainer.addChild(shadowText);
			
			var optionText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
			optionText.position.y = 7;
			optionText.anchor.x = 0.5;
			optionText.position.x = 95/2;
			optionText.tint = 0xaaaaaa;
			//optionText
			optionText.align = BitmapTextAlign.CENTER;
			choiceContainer.addChild(optionText);

			choiceContainer.interactive = true;
			choiceContainer.click = choiceContainer.tap = function( event : pixi.interaction.InteractionEvent ) {  
				AudioManager.instance.play("accept");
				PickSubGroup(group, subgroup); 
				event.stopPropagation(); 
				};
			
			choiceContainer.mouseover = function( event : pixi.interaction.InteractionEvent ) { 
				AudioManager.instance.play("hover");
				TweenX.to( optionText, {tint: RgbColor.of( 0xffffff ) } ).time(0.2);
			};
			choiceContainer.mouseout = function( event : pixi.interaction.InteractionEvent ) { 
				TweenX.to( optionText, {tint: RgbColor.of( 0xaaaaaa ) } ).time(0.2);
			};

			var choiceMargin = 6;
			var choiceSpacing = button.width + choiceMargin;
			var totalWidth = choiceSpacing * subgroups.length;
			var target = 320/2 - ( totalWidth / 2 ) + i * choiceSpacing + choiceMargin/2;

			choiceContainer.y = 180;
			choiceContainer.x = 320;

			TweenX.to( choiceContainer, {x: target } ).time(0.2).delay(0.1 * i);

			containerSubGroupPicker.addChild(choiceContainer);
		}
	}

	public function HideSubGroupPicker()
	{
		containerTextBox.visible = false;
		containerSubGroupPicker.interactive = false;
		TweenX.to( containerSubGroupPicker, { y: 100 } ).time(0.2).onFinish(function(){
			containerSubGroupPicker.removeChildren();
			containerSubGroupPicker.y = 0;
			containerSubGroupPicker.interactive = true;
		});
	}

	public function PickSubGroup( group : String, subGroup : String )
	{
		// Clear out the picker if we put it up.
		HideSubGroupPicker();

		var events = new Array<ld.Types.LDEvent>();
		for( event in gameData.events )
		{
			if( event.group == group && event.subgroup == subGroup )
			{
				var pass = true;
				for( requirement in event.requirements )
				{
					if( !CheckStat( requirement.attribute, requirement.value, requirement.operator ) )
						pass = false;
				}

				if( pass )
					events.push( event );
			}
		}

		if( events.length == 0 )
		{
			trace(" !!! No events matched query: Group: " + group + ", subgroup: " + subGroup + " with given stats:", player.stats );
			ProcessFlag();
			return;
		}

		var idx = Std.random( events.length );
		ProcessEvent( events[idx] );
	}

	public function ProcessEvent( event : ld.Types.LDEvent )
	{
		activeEvent = event;
		textIndex = -1;
		containerTextBox.visible = true;

		containerScene.removeChildren();

		if( event.image != null && event.image.length > 0 )
		{
			var images = event.image.split(",");

			var sprite = new Sprite( Texture.fromImage( images[0] ) );
			containerScene.addChild( sprite );

			if( images.length > 1 )
			{
				var sprite = new Sprite( Texture.fromImage( images[1] ) );
				containerScene.addChild( sprite );
				sprite.y = 2;
				sprite.x = 48;
			}
		}

		AdvanceText();
	}

	public function AdvanceText()
	{
		// Skip to fully rendered text
		if( desiredText.length > 0 && desiredText != infoTextBox.text )
		{
			
			infoTextBox.text = desiredText;
			return;
		}

		if( activeEvent == null )
		{
			return;
		}

		textIndex++;

		if( textIndex + 1 == activeEvent.dialogue.length )
		{
			// Process stats when the last line starts, so we reduce the amount of waiting a player has
			// to do to continue;
			ProcessStats(activeEvent);
		}

		if( textIndex >= activeEvent.dialogue.length )
		{
			containerTextBox.visible = false;
			ProcessFlag();
			return;
		}

		infoTextTimer = 0;
		infoTextBox.text = "";
		desiredText = activeEvent.dialogue[textIndex].text;
		
	}

	public function ProcessStats( event : ld.Types.LDEvent )
	{
		// @todo show stat change 
		var notification = "";
		for( effect in event.effects )
		{
			UpdateStat( effect.attribute, effect.change );
			// Show a stauts message for it if it's localized
			var statName = GetStatLocalization( effect.attribute );
			if( statName != null )
			{
				if( notification.length == 0)
				{
					notification = GetStatString( statName, effect.change );
				} else {
					notification = notification + "\n" + GetStatString( statName, effect.change );
					notificationWindow.ShowNotification(notification);
					notification = "";
				}
			}
			
		}
		if( notification.length > 0 )
			notificationWindow.ShowNotification(notification);
	}

	public function GetStatString( statname : String, change : Int )
	{
		var tint : String;
		if( ( IsStatPositive(statname) && change > 0 ) || ( !IsStatPositive(statname) && change < 0 ) )
			tint = "14ff13";
		else
			tint = "ff1413";


		if( change == 1 )
			return 'Your ^c$tint$statname ^cffffffhas gone up slightly';
		if( change == 2 )
			return 'Your ^c$tint$statname ^cffffffhas gone up!';
		if( change == 3 )
			return 'Your ^c$tint$statname ^cffffffsignificantly increased!';
		if( change > 3 )
			return 'Your see massive gains in the ^c14ff13$statname department';

		if( change == -1 )
			return 'Your ^c$tint$statname ^cffffffhas gone down slightly';
		if( change == -2 )
			return 'Your ^c$tint$statname ^cffffffhas gone down.';
		if( change == -3 )
			return 'Your ^c$tint$statname ^cffffffhas significantly gone down.';
		if( change < -3 )
			return 'Your ^c$tint$statname ^cffffffwashes away.';

		return '*confused barking*';
	}

	public function GetStatLocalization( statname : String )
	{
		if( gameData.localizedStats == null )
		{
			trace("no localized stats ?????");
			return null;
		}
		for( stat in gameData.localizedStats )
		{
			if( stat.id == statname )
				return stat.name;
		}

		return null;
	}

	public function GetStat( statname : String )
	{
		for( stat in player.stats )
		{
			if( stat.name == statname )
				return stat.value;
		}
		
		return 0;
	}

	public function IsStatPositive( statname : String )
	{
		for( stat in gameData.localizedStats )
		{
			if( stat.name == statname )
				return stat.positive;
		}
		
		return false;
	}

	public function UpdateStat ( statname : String, value : Int )
	{
		for( stat in player.stats )
		{
			if( stat.name == statname )
			{
				//trace(stat, value);
				// It was me, Javascript!
				stat.value += Std.parseInt( cast value );
				if( stat.value < 0 )
					stat.value = 0;
				return;
			}
		}
		
		player.stats.push({ name: statname, value:  Std.parseInt( cast value ) });
	}

	public function CheckStat ( stat : String, value : Int, operation: String )
	{
		var playerValue = GetStat(stat);

		switch( operation )
		{
			case ">":
				return playerValue > value;
			case "<":
				return playerValue < value;
			case "=":
				return playerValue == value;
			case "==":
				return playerValue == value;
			case ">=":
				return playerValue >= value;
			case "<=":
				return playerValue <= value;
			case "!=":
				return playerValue != value;
			default:
				trace("Unknown stat operation: " + operation);
				return false;
		}
	}
}
